import env from "../../../env";
import axios from "axios";

const state = {
  employeesData: null,
  companyInfo: null,
  profile: null,
};

const getters = {
  employeesData: (state) => state.employeesData,
  companyInfo: (state) => state.companyInfo,
  profile: (state) => state.profile,
};

// Helper function to check if token is expired
const isTokenExpired = (token) => {
  try {
    // For JWT tokens, split the token and decode the payload
    const base64Url = token.split(".")[1];
    if (!base64Url) return true;

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    const { exp } = JSON.parse(jsonPayload);

    // Check if the expiration time has passed
    return exp ? Date.now() >= exp * 1000 : true;
  } catch (error) {
    console.error("Error checking token expiration:", error);
    return true; // If we can't decode the token, assume it's expired
  }
};

// Helper function to check token validity without making API calls
const isTokenValid = (token) => {
  if (!token || token.trim() === "") return false;
  return !isTokenExpired(token);
};

const actions = {
  isTokenValid({ commit }, token) {
    return isTokenValid(token);
  },

  async fetchGlobalEmployeesApi({ commit }, payload) {
    // console.warn("payload", app);
    // console.warn("payload", app.$router.history.current);
    try {
      let T = localStorage.getItem("Nannotoken");
      if (!T) {
        console.warn("No token found");
        return;
      }

      let token = atob(T);

      // Check if token is valid without making API calls
      if (!isTokenValid(token)) {
        // console.warn("Token expired or invalid");
        localStorage.removeItem("Nannotoken"); // Remove invalid token
        return;
      }

      // app.$router.replace("/pages/employees");

      // console.warn("Token is valid");

      let { data } = await axios.get(`${env.HR()}/api/hr/employees/new`, {
        headers: { Authorization: "Bearer " + token },
      });

      commit("setEmployeesData", data.data);
    } catch (error) {
      console.error("Error fetching employees data:", error);
      // If we get a 401 Unauthorized, the token is invalid/expired
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("Nannotoken");
      }
    }
  },

  async fetchCompanyInfo({ commit }) {
    try {
      let T = localStorage.getItem("Nannotoken");
      if (!T) {
        console.warn("No token found");
        return;
      }

      let token = atob(T);

      // Check if token is valid without making API calls
      if (!isTokenValid(token)) {
        console.warn("Token expired or invalid");
        localStorage.removeItem("Nannotoken"); // Remove invalid token
        return;
      }

      let { data } = await axios.get(`${env.HR()}/api/companyinfos`, {
        headers: { Authorization: "Bearer " + token },
      });

      commit("setCompanyInfo", data.data);
    } catch (error) {
      console.error("Error fetching company info:", error);
      // If we get a 401 Unauthorized, the token is invalid/expired
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("Nannotoken");
      }
    }
  },

  async fetchProfile({ commit }) {
    try {
      let T = localStorage.getItem("Nannotoken");
      if (!T) {
        console.warn("No token found");
        return;
      }

      let token = atob(T);

      // Check if token is valid without making API calls
      if (!isTokenValid(token)) {
        console.warn("Token expired or invalid");
        localStorage.removeItem("Nannotoken"); // Remove invalid token
        return;
      }

      let { data } = await axios.get(`${env.HR()}/api/profile`, {
        headers: { Authorization: "Bearer " + token },
      });

      localStorage.setItem("eid", data.data.employeeId);
      localStorage.setItem("isSalariesEnabled", data.data.isSalariesEnabled);

      localStorage.setItem("privateCompanyMode", data.data.privateCompanyMode);

      localStorage.setItem(
        "isMultiShiftsEnabled",
        data.data.isMultiShiftsEnabled
      );

      commit("setProfile", data.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
      // If we get a 401 Unauthorized, the token is invalid/expired
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("Nannotoken");
      }
    }
  },
};

const mutations = {
  setEmployeesData(state, payload) {
    state.employeesData = payload;
  },
  setCompanyInfo(state, payload) {
    state.companyInfo = payload;
  },
  setProfile(state, payload) {
    state.profile = payload;
  },
  // Called on Logout. Without this, state.profile keeps the PREVIOUS user's
  // data in memory across a login/logout that doesn't reload the page — on
  // a shared browser, the next user's dashboard can mount before their own
  // fetchProfile() resolves and briefly (or, if that fetch ever fails,
  // permanently) read the old user's id. Components that key off
  // global/profile for identity (NovuInbox, PushNotificationBanner) would
  // then send the WRONG subscriberId to Novu. See docs/Notifications.md.
  //
  // Deliberately does NOT touch employeesData/companyInfo — those are
  // tenant/company master data, not per-user identity, and several pages
  // (employees.vue, salary.vue, Salary Reports.vue, Staff Reports.vue,
  // DashboardHR.vue, confirm salary.vue) have an UNGUARDED
  // `watch: { globalEmployeesData(newValue) { this.init() } }` that
  // dereferences newValue directly — nulling it here throws
  // "Cannot read properties of null" in whichever of those pages happens
  // to be mounted when the user logs out. profile is safe to null because
  // NovuInbox/PushNotificationBanner already guard `!this.user`.
  resetProfile(state) {
    state.profile = null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
